<img class="feedback-image" src="../../../assets/images/page-not-found.svg" alt="Page Not Found" />
<div class="message-container">
  <h1 class="message-container__header">Page Not Found</h1>
  <p class="message-container__message">We can't seem to find the page you were looking for.</p>
  <app-further-assistance [showDefaultClientInfo]="true"></app-further-assistance>
</div>
